import { Box } from '@mui/material'
import { ChevronRight20Regular } from '@/components/Icon'
import styles from './selectionSwitchCard.module.scss'

/**
 * @param {{
 *   switchKind: 'agent' | 'persona',
 *   fromLabel: string,
 *   toLabel: string,
 * }} props
 */
export default function SelectionSwitchCard({ switchKind, fromLabel, toLabel }) {
  const kindLabel = switchKind === 'agent' ? 'agent' : 'persona'

  return (
    <Box className={styles.root} role="status" aria-live="polite">
      <span className={styles.prefix}>
        Switching {kindLabel}
      </span>
      <span className={styles.fromLabel}>{fromLabel}</span>
      <ChevronRight20Regular className={styles.chevron} aria-hidden />
      <span className={styles.toLabel}>{toLabel}</span>
    </Box>
  )
}
